import React, { useContext } from 'react';
import { Box } from '@mui/material';
import styles from "./StatusBox.module.css";
import { LanguageContext } from '../../../../context/LanguageContext';
import { ParagraphText } from '../../../../Libraries';

const isItemNameEmpty = (item) => !String(item?.name ?? "").trim();

const StatusBox = ({ analysisData, bulkUploadItems }) => {
    const failedCount = analysisData?.failedEntries?.length || 0;
    const successCount = analysisData?.successfulEntries?.length || 0;
    const [I18n] = useContext(LanguageContext);
    return (
        <Box className={styles.statusWrapper}>
            {/* Urdu/Sindhi read right-to-left so the count sits before the text */}
            <div className={styles.summary} dir={["ur", "snd"].includes(I18n.lang) ? "rtl" : "ltr"}>
                <p className={styles.okText}>{`${successCount} ${I18n.entries_imported_successfully || "entries imported successfully."}`}</p>
                {failedCount > 0 ? (
                    <p className={styles.errorText}>{`${failedCount} ${I18n.entries_failed || "entries failed"}: ${analysisData.failedReason}`}</p>
                ) : null}
            </div>

                <Box className={styles.table}>
                    
                    <Box className={styles.tableHeader}>
                        <Box className={styles.tableHeaderItem}>
                            <ParagraphText className={styles.tableHeaderItemText}> {I18n.sr_no} </ParagraphText>                            
                        </Box>
                        <Box className={styles.tableHeaderItem}>
                            <ParagraphText className={styles.tableHeaderItemText}> {I18n.item_name} </ParagraphText>
                        </Box>
                        <Box className={styles.tableHeaderItem}>
                            <ParagraphText className={styles.tableHeaderItemText}> {I18n.stock} </ParagraphText>
                        </Box>
                        <Box className={styles.tableHeaderItem}>
                            <ParagraphText className={`${styles.tableHeaderItemText} textRight`}> {I18n.cost_price} </ParagraphText>
                        </Box>
                        <Box className={styles.tableHeaderItem}>
                            <ParagraphText className={`${styles.tableHeaderItemText} textRight`}> {I18n.sell_price} </ParagraphText>
                        </Box>
                    </Box>
                    
                    <Box className={`generic-scrollbar ${styles.tableBody}`}>
                        <Box className={styles.tableWrap}>
                            {bulkUploadItems.map((item, index) => {
                                const hasNameError = isItemNameEmpty(item);
                                return (
                                <Box
                                    className={`${styles.tableRow} ${hasNameError ? styles.tableRowError : ""}`}
                                    key={`bulk-upload-row-${index}`}
                                >
                                    <Box className={`truncateOneLine ${styles.tableRowItem}`}>{index + 1}</Box>
                                    <Box className={`${styles.tableRowItem} ${hasNameError ? styles.tableRowItemError : ""}`}>
                                        {item?.name || "--"}
                                    </Box>
                                    <Box className={styles.tableRowItem}>{item?.stock || 0}</Box>
                                    <Box className={`${styles.tableRowItem} textRight`}>{`Rs. ${item?.cost_price || 0}`}</Box>
                                    <Box className={`${styles.tableRowItem} textRight`}>{`Rs. ${item?.selling_price || 0}`}</Box>
                                </Box>
                            );
                            })}
                        </Box>
                    </Box>
                </Box>
        </Box>

    );
};

export default StatusBox;
